// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = (func, options) => {
    let timeout = null;
    let maxWaitTimeout = null;
    let lastArgs = null;
    let maxWait = options.maxWait ?? null;
    let pendingPromises = [];
    const clearTimers = () => {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        if (maxWaitTimeout) {
            clearTimeout(maxWaitTimeout);
            maxWaitTimeout = null;
        }
    };
    const execute = () => {
        if (lastArgs) {
            const args = lastArgs;
            const promises = pendingPromises;
            lastArgs = null;
            pendingPromises = [];
            clearTimers();
            try {
                const result = func(...args);
                // Handle both sync and async functions
                Promise.resolve(result).then((value) => {
                    promises.forEach((p) => p.resolve(value));
                }, (error) => {
                    promises.forEach((p) => p.reject(error));
                });
                return result;
            }
            catch (error) {
                promises.forEach((p) => p.reject(error));
            }
        }
        return undefined;
    };
    const createMaxWaitTimer = () => {
        if (maxWait && !maxWaitTimeout && lastArgs) {
            maxWaitTimeout = setTimeout(execute, maxWait);
        }
    };
    const debouncedFunc = (...args) => {
        lastArgs = args;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(execute, options.delay);
        createMaxWaitTimer();
        return new Promise((resolve, reject) => {
            pendingPromises.push({
                resolve,
                reject,
            });
        });
    };
    debouncedFunc.cancel = () => {
        const promises = pendingPromises;
        lastArgs = null;
        pendingPromises = [];
        clearTimers();
        promises.forEach((p) => p.reject(new Error('Debounced function was cancelled')));
    };
    debouncedFunc.flush = () => {
        return execute();
    };
    debouncedFunc.setMaxWait = (newMaxWait) => {
        if (maxWait === newMaxWait) {
            return;
        }
        maxWait = newMaxWait;
        if (maxWaitTimeout) {
            clearTimeout(maxWaitTimeout);
            maxWaitTimeout = null;
        }
        // if debounce is still running
        // restart the max wait timer
        if (timeout) {
            createMaxWaitTimer();
        }
    };
    debouncedFunc.isPending = () => {
        return Boolean(timeout && lastArgs);
    };
    return debouncedFunc;
};
